// Zwei-Buchstaben-Monogramm aus einem Namen (z.B. "Siemens Mobility" → "SM").
export function initialen(name) {
  if (!name) return '?';
  const result = name
    .split(/\s+/)
    .map((w) => w[0])
    .filter((c) => c && /\p{L}/u.test(c)) // nur Buchstaben-Tokens, kein "+"/"("
    .join('')
    .toUpperCase()
    .slice(0, 2);
  return result || '?';
}
